// import React from 'react'

// const ChatContainer = ({ messages, activeUser, admin, editingMessageId, editText, setEditText, saveEdit, setEditingMessageId, DropdownActions, handleDeleteMessage, messagesEndRef }) => {
//   return (
//      <div className="flex-1 p-2.5 px-5 overflow-y-auto bg-[#f9f7f4] [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
//                 {messages.map((msg, idx) => (
//                   <div
//                     key={idx}
//                     className={`relative my-2.5 p-2 px-3 rounded-lg text-black w-full max-w-[250px] ${msg.sent_by_me ? "bg-[#eee] ml-auto" : "bg-[var(--accent-blue-bg)]"
//                       }`}
//                   >
//                     {/* Only for group messages, show sender info if message is not mine */}
//                     {activeUser?.is_group && !msg.sent_by_me && (
//                       <div className="sender-info">
//                         <img
//                           src={msg.sender?.profile_picture || admin}
//                           width={"10px"}
//                           height={"10px"}
//                           alt={msg.sender?.name}
//                           className="sender-avatar"
//                         />
//                         <span className="sender-name">
//                           {msg.sender?.name}
//                         </span>
//                       </div>
//                     )}

//                     {editingMessageId === msg.id ? (
//                       <div className="edit-mode">
//                         <input
//                           type="text"
//                           value={editText}
//                           onChange={(e) => setEditText(e.target.value)}
//                           className="w-[calc(100%-20px)]"
//                         />

//                         <div className="flex m-2.5">
//                           <button
//                             onClick={() => saveEdit(msg)}
//                             className="submit-upload-btn"
//                           >
//                             Save
//                           </button>

//                           <button
//                             onClick={() => setEditingMessageId(null)}
//                             className="cancel-btn ml-2.5"
//                           >
//                             Cancel
//                           </button>
//                         </div>
//                       </div>
//                     ) : (
//                       <span className="break-all">{msg.message}</span>
//                     )}

//                     {msg.sent_by_me && (
//                       <div className="absolute top-1 right-1 transition-opacity duration-200">
//                         <DropdownActions
//                           onEdit={() => {
//                             setEditingMessageId(msg.id);
//                             setEditText(msg.message);
//                           }}
//                           onDelete={() => handleDeleteMessage(msg)}
//                         />
//                       </div>
//                     )}
//                   </div>
//                 ))}

//                 <div ref={messagesEndRef} />
//               </div>

//   )
// }

// export default ChatContainer
import React, { useState, useRef, useEffect } from 'react'
import { MoreVertical, Edit2, Trash2, Check, X, Clock } from 'lucide-react'
import { Download } from "lucide-react";
const ChatContainer = ({ 
  messages, 
  activeUser, 
  admin, 
  editingMessageId, 
  editText, 
  setEditText, 
  saveEdit, 
  setEditingMessageId, 
  DropdownActions, 
  handleDeleteMessage, 
  messagesEndRef 
}) => {
  const [hoveredMessage, setHoveredMessage] = useState(null)
  const [openDropdownId, setOpenDropdownId] = useState(null)
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Format timestamp to show time
  const formatTime = (timestamp) => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }

  // Custom dropdown for message actions
  const ModernDropdown = ({ messageId, onEdit, onDelete }) => {
    return (
      <div 
        ref={dropdownRef}
        className="relative"
        onMouseEnter={() => setOpenDropdownId(messageId)}
        onMouseLeave={() => {}}
      >
        <button
          onClick={(e) => {
            e.stopPropagation()
            setOpenDropdownId(openDropdownId === messageId ? null : messageId)
          }}
          className="p-1  hover:bg-[#e8f0f7] rounded transition-colors"
          onMouseEnter={() => setOpenDropdownId(messageId)}
          style={{paddingRight:'10px'}}
        >
          <MoreVertical size={16} className="text-[#686868]" />
        </button>
        
        {openDropdownId === messageId && (
          <div 
            className="absolute right-0 top-full mt-1 w-36 bg-white rounded-lg shadow-lg border border-[#dddddd96] z-50 "
            onMouseEnter={() => setOpenDropdownId(messageId)}
            onMouseLeave={() => setOpenDropdownId(null)}
            
          >
            <button
              onClick={(e) => {
                e.stopPropagation()
                onEdit()
                setOpenDropdownId(null)
              }}
              className="w-full px-4 py-2.5 text-left text-sm hover:bg-[#e8f0f7] flex items-center gap-2 text-[#0f6abf]"
            >
              <Edit2 size={14} />
              Edit
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation()
                onDelete()
                setOpenDropdownId(null)
              }}
              className="w-full px-4 py-2.5 text-left text-sm text-[#e74c3c] hover:bg-red-50 flex items-center gap-2"
            >
              <Trash2 size={14} />
              Delete
            </button>
          </div>
        )}
      </div>
    )
  }

  return (
// bg-[#f9f7f4]
<div className="flex-1 p-2.5 px-5 overflow-y-auto bg-gray-50 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
  <div className="space-y-2.5">
    {messages.length === 0 ? (
      <div className="flex flex-col items-center justify-center h-full py-12">
        <div className="w-16 h-16 rounded-full bg-[#e8f0f7] flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0 4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-[#686868] mb-2">No messages yet</h3>
        <p className="text-sm text-[#797979] text-center max-w-md">
          Start the conversation by sending your first message
        </p>
      </div>
    ) : (
      messages.map((msg, idx) => {
        const isOwnMessage = msg.sent_by_me
        const isEditing = editingMessageId === msg.id
        const showTimestamp = idx === messages.length - 1 || 
          new Date(msg.timestamp).getMinutes() !== new Date(messages[idx + 1]?.timestamp).getMinutes()

        return (
          <div
            key={idx}
            className={`flex ${isOwnMessage ? 'justify-end' : 'justify-start'} group`}
            onMouseEnter={() => setHoveredMessage(msg.id)}
            onMouseLeave={() => setHoveredMessage(null)}
          >
            {/* Message bubble */}
            <div
              className={`relative ${isEditing ? 'w-full' : 'max-w-[70%]'} rounded-lg p-3 transition-all duration-200
                ${isOwnMessage
                  ? 'bg-[#EEEEEE] text-black ml-auto'
                  : 'bg-[#e8f0f7] text-black'
                }
                ${isEditing ? 'ring-2 ring-[#0f6abf]' : ''}
                ${hoveredMessage === msg.id ? 'shadow-[0_2px_8px_rgba(0,0,0,0.1)]' : ''}
              `}
              style={{
                borderRadius: isOwnMessage ? '18px 18px 4px 18px' : '18px 18px 18px 4px'
              }}
              onMouseEnter={() => setHoveredMessage(msg.id)}
            >
              {/* Sender info for group messages */}
              {activeUser?.is_group && !isOwnMessage && (
                <div className="flex items-center gap-2 mb-1.5 pb-1.5 border-b border-[#dddddd96]">
                  <img
                    src={msg.sender?.profile_picture || admin}
                    className="mr-2 w-6 h-6 rounded-full border-2 border-white"
                    alt={msg.sender?.name}
                  />
                  <span className="text-xs font-semibold text-[#0f6abf]">
                    {msg.sender?.name}
                  </span>
                </div>
              )}

              {/* Message content */}
              <div className="space-y-1.5">
                {isEditing ? (
                  <div className="w-full space-y-2.5">
                    <input
                      type="text"
                      value={editText}
                      onChange={(e) => setEditText(e.target.value)}
                      className="w-full px-2.5 py-1.5 rounded border border-[#797979] bg-white text-black focus:outline-none focus:border-[#0f6abf]"
                      autoFocus
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') saveEdit(msg)
                        if (e.key === 'Escape') setEditingMessageId(null)
                      }}
                    />
                    <div className="flex gap-1.5">
                      <button
                        onClick={() => saveEdit(msg)}
                        className="px-3 py-1.5 bg-[#0f6abf] text-white text-sm font-medium rounded hover:bg-[#0e5ca5] transition-colors flex items-center gap-1.5"
                      >
                        <Check size={14} />
                        Save
                      </button>
                      <button
                        onClick={() => setEditingMessageId(null)}
                        className="px-3 py-1.5 bg-[#cacbccf7] text-[#686868] text-sm font-medium rounded hover:bg-[#b5b6b7] transition-colors flex items-center gap-1.5"
                      >
                        <X size={14} />
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-full space-y-1 z-10">
                    {/* <p className="text-sm leading-relaxed break-words whitespace-pre-wrap">
                      {msg.message}
                    </p> */}
    {msg.file ? (
  <div className="relative w-full rounded-md overflow-hidden">
    {/* Iframe preview */}
    <iframe
      src={msg.file}
      className="w-full h-60"
      title="File preview"
    />

    {/* Download icon at bottom-right */}
    <div className="absolute bottom-2 right-2 bg-white rounded-full p-1 shadow-md cursor-pointer hover:bg-gray-100">
      <Download
        className="w-5 h-5 text-blue-500"
        onClick={() => window.open(msg.file, "_blank")}
      />
    </div>
  </div>
) : (
  <p className="text-sm leading-relaxed break-words whitespace-pre-wrap max-h-60 overflow-auto scrollbar-hide">
    {msg.message}
  </p>
)}

{/* 
          {msg.file ? (
  <>

    {["png", "jpg", "jpeg", "gif", "webp"].includes(msg.file?.split(".").pop()?.toLowerCase()) && (
      <img
        src={msg.file}
        alt={msg.file_name || "image"}
        className="max-w-xs max-h-60 rounded-md"
      />
    )}

    {["mp4", "webm", "ogg"].includes(msg.file?.split(".").pop()?.toLowerCase()) && (
      <video
        src={msg.file}
        controls
        className="max-w-xs max-h-60 rounded-md"
      />
    )}


    {["mp3", "wav", "ogg", "m4a"].includes(msg.file?.split(".").pop()?.toLowerCase()) && (
      <audio
        src={msg.file}
        controls
        className="w-full"
      />
    )}

    {!["png","jpg","jpeg","gif","webp","mp4","webm","ogg","mp3","wav","m4a"].includes(msg.file?.split(".").pop()?.toLowerCase()) && (
      <a
        href={msg.file}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-500 underline"
      >
        {msg.file_name || "Download file"}
      </a>
    )}
  </>
) : (
  <p className="text-sm leading-relaxed break-words whitespace-pre-wrap">
    {msg.message}
  </p>
)} */}

                    
                    {/* Message metadata */}
                    <div className="flex items-center justify-between mt-1 pt-1 border-t border-[#dddddd50]">
                      <div className="flex items-center gap-1.5">
                        <span className="text-xs text-[#797979]">
                          {formatTime(msg.timestamp)}
                        </span>
                        {msg.status === 'sent' && isOwnMessage && (
                          <Clock size={10} className="text-[#797979]" />
                        )}
                        {msg.status === 'delivered' && isOwnMessage && (
                          <span className="text-xs text-[#797979]">✓✓</span>
                        )}
                        {msg.status === 'read' && isOwnMessage && (
                          <span className="text-xs text-[#0f6abf]">✓✓</span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Edit indicator */}
              {msg.edited && !isEditing && (
                <div className="absolute -bottom-1.5 left-2">
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-[#dddddd50] text-[#797979]">
                    edited
                  </span>
                </div>
              )}

              {/* Message actions (hover) */}
              {isOwnMessage && !isEditing && (
                <div 
                  className={`absolute -right-6 top-1/2 transform -translate-y-1/2 transition-opacity duration-200 ${hoveredMessage === msg.id || openDropdownId === msg.id ? 'opacity-100' : 'opacity-0'}`}
                  onMouseEnter={() => setHoveredMessage(msg.id)}
                  onMouseLeave={() => {
                    if (openDropdownId !== msg.id) {
                      setHoveredMessage(null)
                    }
                  }}
                >
                  {DropdownActions ? (
                    <div onClick={(e) => e.stopPropagation()}>
                      <DropdownActions
                        onEdit={() => {
                          setEditingMessageId(msg.id)
                          setEditText(msg.message)
                        }}
                        onDelete={() => handleDeleteMessage(msg)}
                      />
                    </div>
                  ) : (
                    <ModernDropdown
                      messageId={msg.id}
                      onEdit={() => {
                        setEditingMessageId(msg.id)
                        setEditText(msg.message)
                      }}
                      onDelete={() => handleDeleteMessage(msg)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )
      })
    )}
    <div ref={messagesEndRef} className="h-2.5" />
  </div>

  {/* Typing indicator */}
  {activeUser?.isTyping && (
    <div className="flex justify-start mt-2.5">
      <div className="bg-[#e8f0f7] rounded-lg p-2.5 px-3.75">
        <div className="flex items-center gap-1.5">
          <div className="flex space-x-1">
            <div className="w-1.5 h-1.5 bg-[#686868] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-1.5 h-1.5 bg-[#686868] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-1.5 h-1.5 bg-[#686868] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          <span className="text-xs text-[#686868] ml-1.5">typing...</span>
        </div>
      </div>
    </div>
  )}
</div>
  )
}

export default ChatContainer